import { twJoin } from 'tailwind-merge';
import { Para } from './Para';

type Props = {
  price: number;
  disabled?: boolean;
};

export function BigPriceSquare({ price, disabled = false }: Props): JSX.Element {
  return (
    <div
      className={twJoin(
        'flex items-center justify-center',
        disabled ? 'opacity-50' : 'opacity-100',
      )}
    >
      <Para size="4xl" className="w-72 bg-zinc-100 py-3 text-zinc-800">
        {price} CHF
      </Para>
    </div>
  );
}
